import React, { useEffect, useState } from "react";
import "./Scheme.css";

const API =
  process.env.REACT_APP_API_URL || "https://backend-9i6n.onrender.com";

const ACCENTS = [
  { ink: "#0F5C2E", tint: "#E8F3EA" },
  { ink: "#1466A8", tint: "#E7F0F8" },
  { ink: "#C06A12", tint: "#FBF0E0" },
  { ink: "#B23A55", tint: "#F8E9EC" },
];

const Scheme = () => {
  const [schemes, setSchemes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
    (async () => {
      try {
        const res = await fetch(`${API}/api/schemes`);
        if (!res.ok) throw new Error("Failed");
        const data = await res.json();
        setSchemes(Array.isArray(data) ? data : []);
      } catch {
        setError("योजना लोड करता आल्या नाहीत");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div>
      <section className="rk-hero">
        <div className="rk-hero-inner">
          <div className="rk-crumb">मुख्यपृष्ठ / योजना</div>
          <h1 className="rk-hero-title">शासकीय योजना</h1>
          <p className="rk-hero-sub">केंद्र व राज्य शासनाच्या विविध कल्याणकारी योजनांची माहिती व पात्रता एका ठिकाणी.</p>
        </div>
      </section>

      <section className="rk-wrap">
        {loading ? (
          <p className="rk-loading">योजना लोड होत आहेत...</p>
        ) : error ? (
          <p className="rk-error">⚠️ {error}</p>
        ) : schemes.length === 0 ? (
          <p className="rk-empty">कोणतीही योजना उपलब्ध नाही</p>
        ) : (
          <div className="rk-cols rk-cols-2">
            {schemes.map((s, i) => {
              const a = ACCENTS[i % ACCENTS.length];
              return (
                <div key={s._id} className="rk-card rk-scheme" style={{ borderTop: `4px solid ${a.ink}` }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 14 }}>
                    <h3 style={{ fontWeight: 700, fontSize: 20, color: "#17241C", lineHeight: 1.3 }}>{s.title}</h3>
                    <span style={{ fontSize: 12, fontWeight: 700, color: a.ink, background: a.tint, padding: "4px 11px", borderRadius: 100, whiteSpace: "nowrap", flexShrink: 0 }}>
                      {s.schemeType === "State" ? "राज्य" : "केंद्र"}
                    </span>
                  </div>
                  {s.description && <p style={{ color: "#5B6B60", fontSize: 15, lineHeight: 1.6, marginTop: 10 }}>{s.description}</p>}
                  <div className="rk-scheme-meta">
                    <div>
                      <div style={{ fontSize: 12, color: "#8a9990" }}>लाभ</div>
                      <div style={{ fontSize: 14, fontWeight: 600, color: "#1466A8" }}>{s.benefits || "—"}</div>
                    </div>
                    <div>
                      <div style={{ fontSize: 12, color: "#8a9990" }}>पात्रता</div>
                      <div style={{ fontSize: 14, fontWeight: 600, color: "#17241C" }}>{s.eligibility || "—"}</div>
                    </div>
                  </div>
                  {s.applyLink ? (
                    <a href={s.applyLink} target="_blank" rel="noopener noreferrer" className="rk-soft-btn" style={{ marginTop: 18, display: "inline-block", textDecoration: "none" }}>अर्ज व माहिती →</a>
                  ) : s.applyProcess ? (
                    <div style={{ marginTop: 14, fontSize: 13.5, color: "#42524a" }}><b>अर्ज प्रक्रिया:</b> {s.applyProcess}</div>
                  ) : null}
                </div>
              );
            })}
          </div>
        )}
      </section>
    </div>
  );
};

export default Scheme;
